var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","width":"100%","height":"100%"}},[_c('canvas',{ref:"myChart",staticStyle:{"width":"100%","height":"100%"},on:{"click":function($event){$event.stopPropagation();}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-914ad710","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./Content/src/components/Chart.vue
// module id = 952
// module chunks = 1